<template>
  <div class="dialog-wrapper">
    <div class="dialog-mask"></div>
    <div class="content">
      <div class="title">{{ title }}</div>
      <div class="close" @click="$emit('close')"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题",
    },
  },
  created() {
    console.log("start");
    document.body.classList.add("no-scroll");
    this.$on("hook:beforeDestory", () => {
      console.log("remove");
      document.body.classList.remove("no-scroll");
    });
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
  },
};
</script>

<style lang="scss">
.dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .content {
    padding: 0.28rem 0.35rem;
    position: relative;
    background-color: #fff;
    .title {
      font-size: 0.18rem;
      font-weight: bold;
      margin-bottom: 0.27rem;
    }
    .close {
      position: absolute;
      right: 0.38rem;
      top: 0.29rem;
      width: 0.14rem;
      height: 0.14rem;
      background-image: url(../../assets/images/close.png);
      background-size: cover;
      cursor: pointer;
    }
  }
}
</style>
